<template>
  <div>
    <va-aside-layout :title="asideTitle">
      <pqrs-show v-if="show" :item="item"></pqrs-show>
      <pqrs-form v-else :id="id" :item="item" @saved="onSaved"></pqrs-form>
    </va-aside-layout>
    <base-material-card :icon="resource.icon" :title="title">
      <va-list ref="list" disable-create-redirect @action="onAction">
        <va-data-table
          :fields="fields"
          disable-create-redirect
          disable-show-redirect
          disable-edit-redirect
          @item-action="onAction"
        >
          <template v-slot:[`item.actions`]="{ resource, item }">
            <impersonate-button
              :resource="resource"
              :item="item"
              icon
            ></impersonate-button>
          </template>
        </va-data-table>
      </va-list>
    </base-material-card>
  </div>
</template>

<script>

export default {
  components: {},
  props: ["resource", "title"],
  data() {
    return {
        fields: [{ source: "request", sortable: true }, { source: "answer" }],
      asideTitle: null,
      id: null,
      item: null,
      show: false,
    };
  },
  methods: {
    async onAction({ action, title, id, item }) {
      this.asideTitle = title;
      this.id = id;
      this.show = action === "show";
      this.item = item;
    },
    onSaved() {
      this.asideTitle = null;
      this.$refs.list.fetchData();
    },
  },
};
</script>
